import { render } from "./MenuItemsPanel.vue?vue&type=template&id=0533730d"
import script from "./MenuItemsPanel.vue?vue&type=script&lang=js"
export * from "./MenuItemsPanel.vue?vue&type=script&lang=js"

import "./MenuItemsPanel.vue?vue&type=style&index=0&id=0533730d&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__